import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "col-lg-5 text-right" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "container" }
const _hoisted_11 = {
  key: 0,
  style: {"margin-bottom":"50px"}
}
const _hoisted_12 = { class: "table table-striped table-hover" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { style: {"margin-bottom":"40px"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "input-group mb-3" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  class: "col-sm-6",
  style: {"margin-bottom":"20px"}
}
const _hoisted_19 = { class: "card bg-light" }
const _hoisted_20 = { class: "card-header" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "card-title" }
const _hoisted_24 = { class: "card-text" }

import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute } from 'vue-router'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import FileUploader from '@Blobs/Components/FileUploader.vue'

    import
        {
            useWorkspaceMembersQueryV1
        } from '@Organizations/Workspaces/queries-vue-composables'

    import
        {
            useAddUserToWorkspaceCommandV1,
            useInviteToWorkspaceCommandV1,
            useRemoveUserFromWorkspaceCommandV1,
            useImportToWorkspaceCommandV1
        } from '@Organizations/Workspaces/commands-vue-composables'

    // ---------------- route / base ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageWorkspacePage',
  setup(__props) {

    const route = useRoute()
    const id = computed(() => String(route.params.id))

    // ---------------- local state ----------------

    const file = ref<File | null>(null)
    const inputRecipientEmail = ref<string | null>(null)
    const userId = ref<any | null>(null)
    const blobId = ref<string | null>(null)

    // ---------------- queries ----------------


    const {
        runWorkspaceMembersQueryV1,
        modelWorkspaceMembersQueryV1: model
    } = useWorkspaceMembersQueryV1(id)


    // ---------------- commands ----------------

    const { invokeAddUserToWorkspaceCommandV1,
        onSucceedAddUserToWorkspaceCommandV1        
    } = useAddUserToWorkspaceCommandV1(id, userId)

    const { invokeRemoveUserFromWorkspaceCommandV1,
        onSucceedRemoveUserFromWorkspaceCommandV1
    } = useRemoveUserFromWorkspaceCommandV1(id, userId)

    const { 
        invokeInviteToWorkspaceCommandV1,
        onSucceedInviteToWorkspaceCommandV1
    } = useInviteToWorkspaceCommandV1(id, inputRecipientEmail)

    const {
        invokeImportToWorkspaceCommandV1,
        invokingImportToWorkspaceCommandV1,
        succeedImportToWorkspaceCommandV1
    } = useImportToWorkspaceCommandV1(id, blobId)

    // ---------------- derived ----------------

    const organizationUnitId = computed(() => model.value?.OrganizationUnitId)
    const workspaceName = computed(() => model.value?.WorkspaceName)
    const usersInWorkspace = computed(() => model.value?.UsersInWorkspace ?? [])
    const usersNotInWorkspace = computed(() => model.value?.UsersNotInWorkspace ?? [])
    const invitations = computed(() => model.value?.Invitations ?? [])
    const title = computed(() => `Manage ${workspaceName.value || 'workspace'}`)

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        runWorkspaceMembersQueryV1()
    })

    watch(title, newTitle =>
    {
        document.title = newTitle
    })

    // ---------------- command side-effects ----------------

    function refreshMembers()
    {
        runWorkspaceMembersQueryV1()
    }

    onSucceedAddUserToWorkspaceCommandV1(refreshMembers)
    onSucceedInviteToWorkspaceCommandV1(refreshMembers)
    onSucceedRemoveUserFromWorkspaceCommandV1(refreshMembers)

    watch(succeedImportToWorkspaceCommandV1, succeed =>
    {
        if (succeed === true)
        {
            alert(`Portfolio imported successfully into '${workspaceName.value}'`)
        }
        else if (succeed === false)
        {
            alert('Import failed')
        }
    })

    // ---------------- handlers ----------------

    function handleAddUserToWorkspaceCommandV1(user: any)
    {
        userId.value = user.UserId;
        invokeAddUserToWorkspaceCommandV1()
        userId.value = null;
    }

    function handleRemoveUserFromWorkspaceCommandV1(user: any)
    {
        if (confirm(`Do you want to remove user ${user.Email} from workspace?`))
        {
            invokeRemoveUserFromWorkspaceCommandV1({ userId: user.UserId })
        }
    }

    function handleInviteToWorkspaceCommandV1()
    {
        if (!inputRecipientEmail.value) return

        invokeInviteToWorkspaceCommandV1()
        inputRecipientEmail.value = null
    }

    function handleFileUploaded(bId: string)
    {
        if (!file.value) return

        if (!confirm(`Do you really want to import '${file.value.name}' into '${workspaceName.value}' workspace?`))
            return


        blobId.value = bId;
        invokeImportToWorkspaceCommandV1()
        blobId.value = null
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (organizationUnitId.value)
        ? (_openBlock(), _createBlock(AdminNavigationV2, {
            key: 0,
            tid: organizationUnitId.value
          }, null, 8 /* PROPS */, ["tid"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(title.value), 1 /* TEXT */),
          _createElementVNode("a", {
            href: `/#/admin/organizations/workspaces/${organizationUnitId.value}`,
            class: "btn btn-link btn-sm"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_6),
          _createElementVNode("a", {
            href: `/#/admin/organizations/workspaces/edit/${id.value}`,
            class: "btn btn-link btn-sm"
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", {
              class: "fa fa-pencil",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Edit ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(FileUploader, {
            ttl: 60,
            skipConfirmation: true,
            hideProgress: true,
            onSelected: _cache[0] || (_cache[0] = ($event: any) => (file.value=$event)),
            onUploaded: handleFileUploaded
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                disabled: _unref(invokingImportToWorkspaceCommandV1),
                class: "btn btn-success"
              }, "Upload portfolio", 8 /* PROPS */, _hoisted_9)
            ]),
            _: 1 /* STABLE */
          })
        ])
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_10, [
      (usersInWorkspace.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "fg-color-blue" }, "Members", -1 /* CACHED */)),
            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("table", _hoisted_12, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersInWorkspace.value, (u) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(u.DisplayName), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(u.Email), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(u.IsExternal ? 'External' : 'Organization'), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (handleRemoveUserFromWorkspaceCommandV1(u)),
                        class: "btn btn-secondary btn-sm pull-right"
                      }, " Remove an access ", 8 /* PROPS */, _hoisted_13)
                    ])
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_14, [
        _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "fg-color-blue" }, "Invite people from outside the organization", -1 /* CACHED */)),
        (invitations.value.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invitations.value, (email) => {
                return (_openBlock(), _createElementBlock("li", { key: email }, "Pending invitation for " + _toDisplayString(email), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputRecipientEmail).value = $event)),
            type: "text",
            class: "form-control",
            placeholder: "By email"
          }, null, 512 /* NEED_PATCH */), [
            [
              _vModelText,
              inputRecipientEmail.value,
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("div", { class: "input-group-append" }, [
            _createElementVNode("button", {
              onClick: handleInviteToWorkspaceCommandV1,
              class: "btn btn-primary",
              type: "button"
            }, "Invite")
          ])
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersNotInWorkspace.value, (u) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Organization user ", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (handleAddUserToWorkspaceCommandV1(u)),
                    class: "btn btn-primary btn-sm pull-right"
                  }, [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" Add ", -1 /* CACHED */),
                    _createElementVNode("i", {
                      class: "fa fa-plus",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_21)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h5", _hoisted_23, _toDisplayString(u.DisplayName), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_24, [
                    _createElementVNode("em", null, _toDisplayString(u.Email), 1 /* TEXT */)
                  ])
                ])
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}
}

})